import styled from 'styled-components'
import { DefaultFontStyle } from '../../../styles/global-styles'
import { Card } from '../Card/card-styles'

const StyledContentCard = styled(Card)`
  background-color: ${props => props.theme.colours.white};
  padding: 28px 20px 22px;
  box-shadow: ${props => props.theme.boxShadow};

  @media (min-width: ${props => props.theme.breakpoints.md}px) {
    padding: 30px;
    margin-bottom: 0;
    height: 100%;
  }
`

const Header = styled.h2`
  ${DefaultFontStyle};
  color: ${props => props.theme.colours.black};
  margin: 0px 10px 10px 0px;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;

  @media (min-width: ${props => props.theme.breakpoints.lg}px) {
    font-size: 30px;
    line-height: 45px;
  }
`

type ContentCardProps = {
  header: string
  children: JSX.Element | JSX.Element[]
}

const ContentCard = ({ header, children }: ContentCardProps) => {
  return (
    <StyledContentCard>
      <Header>{header}</Header>
      {children}
    </StyledContentCard>
  )
}

export default ContentCard
